import { User } from "interfaces/user";

export interface TrengoContactData {
	email: string;
	name: string;
	custom_fields?: Array<{
		field_id: number;
		value: string;
	}>;
}

/**
 * Initializes Trengo widget by loading the embed script
 * Should be called only after user authentication
 */
export const initializeTrengoWidget = (): void => {
	const windowFork = window as any;

	// Initialize Trengo object with API key
	windowFork.Trengo = windowFork.Trengo || {};
	windowFork.Trengo.key = "8D6H1rtfuCjRvXX";

	// Load Trengo embed script
	const script = document.createElement("script");
	script.type = "text/javascript";
	script.async = true;
	script.src = "https://static.widget.trengo.eu/embed.js";
	document.head.appendChild(script);

	console.log("[Trengo] Widget initialization script loaded");
};

/**
 * Sets user contact data in the Trengo widget
 * This allows pre-filling the contact form with user information
 */
export const setTrengoContactData = (user: User | null): void => {
	if (!user) return;

	const contactData: TrengoContactData = {
		email: user.email,
		name: `${user.name} ${user.lastName}`.trim(),
	};

	// Ensure window.Trengo object exists
	const windowFork = window as any;
	windowFork.Trengo = windowFork.Trengo || {};

	// Set the contact data
	windowFork.Trengo.contact_data = contactData;

	console.log("[Trengo] Contact data set:", contactData);
};
